import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { alertActions } from "../../../actions";
import { userLogout } from "../../../actions/UserAction";
import { useSelector } from "react-redux";
import { MyAccountService } from "../../../services";

const useTopBar = () => {
  const [locationData, setlocationData] = useState("");
  const navigate = useNavigate();
  const [locInfo, setLocInfo] = useState("");
  const dispatch = useDispatch();
  const [openAccount, setOpenAccount] = useState(false);
  const [cartCount, setCartCount] = useState("");
  const showAccount = () => {
    setOpenAccount(!openAccount);
  };
  const user_id = useSelector((state) => state?.userData?.user?._id);

  /**
   * get place
   */
  useEffect(() => {
    getPlaceList();
  }, []);

  /**
   * get place list
   */
  const getPlaceList = () => {
    if (user_id) {
      MyAccountService.getCartCount()
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            console.log(res?.data?.data);
            setCartCount(res?.data?.data?.[0]?.totalDocuments);
          }
        })
        .catch((error) => {
          console.log("Errorreg", error);
          dispatch(alertActions.error(error));
        });
    }
  };
  /**
   * change select
   * @param {*} e
   */
  const changeSelect = (e) => {
    var id = JSON.parse(e.target.value);
    setLocInfo(id?.rooms_type?.[0]?.location);
    navigate("/", {
      state: { id: id?._id, loc: id?.rooms_type?.[0]?.location },
    });
  };

  /**
   * loin redirect
   */
  const loginRedirect = () => {
    navigate("/Login");
  };

  const cartPage = () => {
    if (user_id) {
      navigate("/cart-page");
    } else {
      dispatch(alertActions.error("Please login to your account"));
      navigate("/Login");
    }
  };

  const navigateToMyAccount = () => {
    navigate("/myAccount");
  };

  /**
   * handle logout
   */
  const handleLogout = () => {
    dispatch(userLogout());
    navigate("/");
    setCartCount("");
    dispatch(alertActions.success("Logout Success"));
    window.location.reload();
  };
  /**
   * go to home
   */
  const gotoHome = () => {
    localStorage.removeItem("datetime1");
    localStorage.removeItem("datetime2");
    localStorage.removeItem("datetimes");
    localStorage.removeItem("datetimes1");
    navigate("/");
  };

  return {
    gotoHome,
    locationData,
    locInfo,
    openAccount,
    user_id,
    cartCount,
    showAccount,
    changeSelect,
    loginRedirect,
    cartPage,
    navigateToMyAccount,
    handleLogout,
  };
};
export default useTopBar;
